'use client';

import { linkButtonTitles } from '@monoimin/intl';
import { FormButton, LinkButton, LinkButtonProps } from '@monoimin/atoms';
import { Locales } from '@monoimin/sb-types';

export const SectionLinkButton = ({
  locale,
  href,
  children,
  className,
  size = 'default',
}: LinkButtonProps & { locale: Locales }) => {
  if (!href || href === '/') {
    return null;
  }
  if (href.includes('?')) {
    return (
      <FormButton
        variant='secondary'
        size={size}
        className={className}
        onClick={() => window.open(href, '_blank', 'noopener,noreferrer')}
      >
        {children || linkButtonTitles[locale]}
      </FormButton>
    );
  }
  return (
    <LinkButton
      href={href}
      className={className}
      variant='secondary'
      target='_blank'
      size={size}
    >
      {children || linkButtonTitles[locale]}
    </LinkButton>
  );
};
